// Lightweight Power BI load timing. Logs to the console as
//   [PBI timing] <step>: <ms since page load> (+<ms since previous step>)
// and records performance marks visible in the DevTools Performance tab.
// Set localStorage 'onedata:pbi-timing' = 'off' to silence it.

let lastMark = null;

const isEnabled = () => {
  try {
    return localStorage.getItem('onedata:pbi-timing') !== 'off';
  } catch (e) {
    return true;
  }
};

const pbiMark = (step, extra = '') => {
  if (!isEnabled() || typeof performance === 'undefined') return;
  const now = performance.now();
  const sincePrev = lastMark === null ? '' : ` (+${Math.round(now - lastMark)}ms)`;
  lastMark = now;
  try {
    performance.mark(`pbi:${step}`);
  } catch (e) {
    // ignore
  }
  // eslint-disable-next-line no-console
  console.info(
    `[PBI timing] ${step}: ${Math.round(now)}ms${sincePrev}${extra ? ` ${extra}` : ''}`,
  );
};

export default pbiMark;
